module.exports = __webpack_public_path__ + "static/media/Hiker.fc3902be.jpg";